export default __webpack_public_path__ + "static/columbus-icon-a11fb964de1c99d62760427d05c7443c.svg";